<script lang="ts">
	import { profileStore } from '$lib/user';
	import { getSystemname } from '$lib/locations';
	import { goto } from '$app/navigation';
	import placenamesStore from '$lib/locations/placenames.store';

	// const onSignout = async () => {
	// 	const { paraLogout } = await import('$lib/user/para/functions');
	// 	await paraLogout();
	// };

	// let moreToggle = false;

	let hrefB = '/member/nobloomyet';

	// Track which sections are expanded
	let expandedSections = {
		create: false,
		connect: false,
		trade: false,
		learn: false,
		engage: false
	};

	const toggleSection = (section: keyof typeof expandedSections) => {
		expandedSections = { ...expandedSections, [section]: !expandedSections[section] };
	};

	const getLocalBloomRoute = async (localbloom: string) => {
		// console.log('localbloom', localbloom);
		const route = await getSystemname(localbloom);
		// console.log('route', route);
		const href = `/${route}`;
		goto(href);
	};

	async function handleRoute() {
		const localbloom = $profileStore.localbloom;
		if (localbloom && $placenamesStore.includes(localbloom)) {
			await getLocalBloomRoute(localbloom);
		} else {
			// Handle case where localbloom doesn't exist
			goto(hrefB);
		}
	}

	// const toggleMore = () => {
	// 	moreToggle = !moreToggle;
	// };
</script>

<aside
	class="hidden lg:block h-full w-64 bg-cosmicPurple800 z-10 lg:h-auto lg:w-48 2xl:w-64 4xl:w-72 pt-28 sidebar"
>
	<ul
		class="py-4 !text-cosmicPurple100 text-left font-semibold font-exo ml-2 lg:-ml-1 2xl:ml-2 sticky"
	>
		<li class="grid grid-cols-5 items-center px-3 py-0 2xl:py-1 hover:bg-cosmicPurplebg">
			<svg
				class="mx-auto lg:scale-75 2xl:scale-100"
				xmlns="http://www.w3.org/2000/svg"
				width="31.41"
				height="24.46"
				><path
					d="M31.41 0C27.2 3.5 23.36 3.43 18.7 6.03s-4.87 6.54-4.87 6.54c-.15-1.11.13-3.7.13-3.7-1.46 1.91-1.56 3.71-1.37 6.77s-.24 5.81-.33 6.31.3.78.3.78c.12-.66.54-3.2.74-3.68 1.67-3.93 6.3-4.86 10.33-6.66 4.51-2.02 5.36-3.9 5.36-3.9a9.37 9.37 0 0 1-2.37.92C31.74 5.99 31.41 0 31.41 0ZM23.1 7.18c-4.04 1.9-7.44 3.71-9.53 10.18l-.65 1.98s-.18-.2.11-1.73c1.26-6.6 5.72-9.02 9.87-10.86C29.66 3.74 31.12.72 31.12.72s-.4 2.52-5.61 5.32c-.8.43-1.63.78-2.42 1.15Z"
					style="stroke-width:0;fill:#a5b9f6"
				/><text
					transform="translate(0 16.78)"
					style="fill:#a5b9f6;font-family:SofiaProSoftBold,'Sofia Pro Soft';font-size:17px"
					><tspan x="0" y="0">+</tspan></text
				></svg
			>

			<a
				rel="noreferrer"
				href="/create/creative/"
				class="col-span-4 block px-3 py-2 text-xs 2xl:text-base font-semibold 2xl:font-bold hover:bg-cosmicPurplebg"
				>Post</a
			>
		</li>
		<li class="grid grid-cols-5 items-center px-3 py-0 2xl:py-1 hover:bg-cosmicPurplebg">
			<svg
				class="mx-auto lg:scale-75 2xl:scale-100"
				version="1.1"
				id="Layer_1"
				xmlns="http://www.w3.org/2000/svg"
				x="0"
				y="0"
				width="30"
				height="30"
				viewBox="0 0 35 35"
				style="enable-background:new 0 0 35 35"
				xml:space="preserve"
				><style>
					.st0 {
						fill: #a5b9f6;
					}
				</style><path
					class="st0"
					d="M16.9 7.1c0 .3.2.5.4.6h.3c.4 0 .7-.3.7-.6l-.1-4.2c0-.3-.3-.6-.7-.6-.4 0-.7.3-.7.6l.1 4.2zM5.3 9.5l3.4 2.7c.1.1.1.1.2.1.3.1.6 0 .7-.2.3-.3.2-.6-.1-.9L6.3 8.6c-.3-.2-.7-.2-1 0-.3.3-.2.7 0 .9zM26 12.3c.1.1.1.1.2.1.2.1.5.1.8-.1l3.5-2.9c.3-.2.3-.6 0-.9s-.7-.3-1 0L26 11.4c-.3.2-.3.6 0 .9zM23.6 20.8c0-3.9-2-7.5-5.5-10.2-.3-.2-.6-.2-.9 0-3.6 2.7-5.5 6.3-5.5 10.2s2 7.5 5.5 10.2c.1.1.3.1.5.1s.3-.1.5-.1c3.4-2.8 5.4-6.4 5.4-10.2z"
					style="fill:#a5b9f6"
				/><path
					class="st0"
					d="M4.8 18.5s-.1 0 0 0c-.4 0-.7.3-.7.6 0 3.2 1.4 6.2 4 8.5 1.9 1.7 4.4 2.9 7 3.3-3.1-2.8-4.8-6.4-4.8-10.1 0-.4 0-.8.1-1.2-1.8-.7-3.7-1.1-5.6-1.1zM20.1 30.9c2.7-.4 5.1-1.6 7-3.3 2.6-2.3 4-5.3 3.9-8.5 0-.3-.3-.6-.7-.6-1.9 0-3.8.4-5.5 1 0 .4.1.8.1 1.2.1 3.8-1.7 7.4-4.8 10.2z"
					style="fill:#a5b9f6"
				/></svg
			>

			<div
				on:click={handleRoute}
				on:keyup={handleRoute}
				role="button"
				tabindex="0"
				class="block col-span-4 px-3 py-2 2xl:text-base font-semibold 2xl:font-bold hover:bg-cosmicPurplebg cursor-pointer text-sm"
			>
				My Local Bloom
			</div>
		</li>
		<li class="grid grid-cols-5 items-center px-3 py-0 2xl:py-1 hover:bg-cosmicPurplebg">
			<svg
				class="mx-auto lg:scale-75 2xl:scale-100 cursor-pointer outline-none"
				xmlns="http://www.w3.org/2000/svg"
				width="27.43"
				height="24"
				viewBox="0 0 27.43 24"
				role="menuitem"
				tabindex="0"
			>
				<path
					d="m7.99 1.76-.56 1.67h-4C1.54 3.43 0 4.97 0 6.86v13.71C0 22.46 1.54 24 3.43 24H24c1.89 0 3.43-1.54 3.43-3.43V6.86c0-1.89-1.54-3.43-3.43-3.43h-4l-.56-1.67A2.57 2.57 0 0 0 17 0h-6.58C9.31 0 8.33.71 7.98 1.76Zm5.72 6.81c2.84 0 5.14 2.3 5.14 5.14s-2.3 5.14-5.14 5.14-5.14-2.3-5.14-5.14 2.3-5.14 5.14-5.14Z"
					style="fill:#a5b9f6;stroke-width:0"
				/>
			</svg>

			<a
				rel="noreferrer"
				href="/communityposts"
				class="col-span-4 block px-3 py-2 text-xs 2xl:text-base font-semibold 2xl:font-bold hover:bg-cosmicPurplebg"
				>Bloom Feed</a
			>
		</li>

		<!-- Connect Section -->
		<li class="px-3 py-1">
			<button
				class="w-full flex items-center justify-between text-xs 2xl:text-base font-bold hover:bg-cosmicPurplebg px-2 py-1 rounded"
				on:click={() => toggleSection('connect')}
			>
				<span>Connect</span>
				<svg
					class="w-4 h-4 transform transition-transform {expandedSections.connect
						? 'rotate-180'
						: ''}"
					viewBox="0 0 20 20"
					fill="currentColor"
				>
					<path
						fill-rule="evenodd"
						d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
						clip-rule="evenodd"
					/>
				</svg>
			</button>
			{#if expandedSections.connect}
				<ul class="mt-1">
					<li class="grid grid-cols-5 items-center px-3 py-0 2xl:py-1 hover:bg-cosmicPurplebg">
						<svg
							class="mx-auto lg:scale-75 2xl:scale-100 transform -scale-x-100"
							width="22"
							height="27"
							xmlns="http://www.w3.org/2000/svg"
							viewBox="0 0 25 25"
							style="enable-background:new 0 0 25 25"
							xml:space="preserve"
							><path style="fill:none" d="M0 0h25v25H0z" /><path
								d="M12.5 1.6C5.6 1.6 0 6.1 0 11.7c0 2.4 1 4.7 2.8 6.4-.5 1.7-1.5 3.3-2.7 4.7-.1.1-.2.3-.1.4.1.1.2.2.4.2 2.5-.1 4.9-.9 6.9-2.5 1.7.6 3.5 1 5.2 1 6.9 0 12.5-4.6 12.5-10.2S19.4 1.6 12.5 1.6z"
								style="fill:#a5b9f6"
							/></svg
						>
						<a
							rel="noreferrer"
							href="/chat"
							class="block col-span-4 px-3 py-2 text-xs 2xl:text-base font-semibold 2xl:font-bold hover:bg-cosmicPurplebg"
							>Chat</a
						>
					</li>

					<li class="grid grid-cols-5 items-center px-3 py-0 2xl:py-1 hover:bg-cosmicPurplebg">
						<svg
							class="mx-auto lg:scale-75 2xl:scale-100"
							xmlns="http://www.w3.org/2000/svg"
							width="25"
							height="25"
							viewBox="0 0 30 30"
							style="enable-background:new 0 0 33 33"
							xml:space="preserve"
							><path
								d="M24.4 30.8v-8.3c0-.8.5-1.3 1-1.2.5.1 1.1 1.4 2.8 1.3 1.7-.1 2.5-1.7 2.5-2.9s-.9-2.8-2.5-2.9c-1.7-.1-2.3 1.1-2.8 1.3-.6.1-1-.4-1-1.2V8.6h-8.3c-.8 0-1.3-.5-1.2-1 .1-.5 1.4-1.1 1.3-2.8s-1.7-2.5-2.9-2.5-2.8.9-2.9 2.5c-.1 1.7 1.1 2.3 1.3 2.8.1.6-.4 1-1.2 1H2.2v8.3c0 .8.5 1.3 1 1.2.5-.1 1.1-1.4 2.8-1.3s2.5 1.7 2.5 2.9-.9 2.8-2.5 2.9-2.3-1.1-2.8-1.3c-.6-.1-1 .4-1 1.2v8.3h22.2z"
								style="fill:#a5b9f6"
							/></svg
						>
						<a
							rel="noreferrer"
							href="/member/viewGifts/"
							class="block col-span-4 px-3 py-2 text-xs 2xl:text-base font-semibold 2xl:font-bold hover:bg-cosmicPurplebg"
							>Bloomers</a
						>
					</li>
					<li class="grid grid-cols-5 items-center px-3 py-0 2xl:py-1 hover:bg-cosmicPurplebg">
						<svg
							class="mx-auto lg:scale-75 2xl:scale-100"
							width="25"
							height="29"
							xmlns="http://www.w3.org/2000/svg"
							viewBox="0 0 512 512"
							style="enable-background:new 0 0 512 512"
							xml:space="preserve"
							><path
								d="m47.6 300.4 180.7 168.7c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9l180.7-168.7c30.4-28.3 47.6-68 47.6-109.5v-5.8c0-69.9-50.5-129.5-119.4-141-45.6-7.6-92 7.3-124.6 39.9l-12 12-12-12c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5z"
								style="fill:#a5b9f6"
							/></svg
						>
						<a
							rel="noreferrer"
							href="/engage/communityCalls"
							class="block col-span-4 px-3 py-2 text-xs 2xl:text-base font-semibold 2xl:font-bold hover:bg-cosmicPurplebg"
							>Community Calls</a
						>
					</li>
				</ul>
			{/if}
		</li>

		<!-- Trade Section -->
		<li class="px-3 py-1">
			<button
				class="w-full flex items-center justify-between text-xs 2xl:text-base font-bold hover:bg-cosmicPurplebg px-2 py-1 rounded"
				on:click={() => toggleSection('trade')}
			>
				<span>Trade</span>
				<svg
					class="w-4 h-4 transform transition-transform {expandedSections.trade
						? 'rotate-180'
						: ''}"
					viewBox="0 0 20 20"
					fill="currentColor"
				>
					<path
						fill-rule="evenodd"
						d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
						clip-rule="evenodd"
					/>
				</svg>
			</button>
			{#if expandedSections.trade}
				<ul class="mt-1">
					<li class="grid grid-cols-5 items-center px-3 py-0 2xl:py-1 hover:bg-cosmicPurplebg">
						<svg
							class="mx-auto lg:scale-75 2xl:scale-100"
							xmlns="http://www.w3.org/2000/svg"
							width="25"
							height="25"
							viewBox="0 0 30 30"
							style="enable-background:new 0 0 33 33"
							xml:space="preserve"
							><path
								d="M24.4 30.8v-8.3c0-.8.5-1.3 1-1.2.5.1 1.1 1.4 2.8 1.3 1.7-.1 2.5-1.7 2.5-2.9s-.9-2.8-2.5-2.9c-1.7-.1-2.3 1.1-2.8 1.3-.6.1-1-.4-1-1.2V8.6h-8.3c-.8 0-1.3-.5-1.2-1 .1-.5 1.4-1.1 1.3-2.8s-1.7-2.5-2.9-2.5-2.8.9-2.9 2.5c-.1 1.7 1.1 2.3 1.3 2.8.1.6-.4 1-1.2 1H2.2v8.3c0 .8.5 1.3 1 1.2.5-.1 1.1-1.4 2.8-1.3s2.5 1.7 2.5 2.9-.9 2.8-2.5 2.9-2.3-1.1-2.8-1.3c-.6-.1-1 .4-1 1.2v8.3h22.2z"
								style="fill:#a5b9f6"
							/></svg
						>
						<a
							rel="noreferrer"
							href="/member/flo/offers"
							class="block col-span-4 px-3 py-2 text-xs 2xl:text-base font-semibold 2xl:font-bold hover:bg-cosmicPurplebg"
							>FLO Exchange</a
						>
					</li>
					<li class="grid grid-cols-5 items-center px-3 py-0 2xl:py-1 hover:bg-cosmicPurplebg">
						<svg
							class="mx-auto lg:scale-75 2xl:scale-100"
							width="25"
							height="29"
							xmlns="http://www.w3.org/2000/svg"
							viewBox="0 0 512 512"
							style="enable-background:new 0 0 512 512"
							xml:space="preserve"
							><path
								d="m47.6 300.4 180.7 168.7c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9l180.7-168.7c30.4-28.3 47.6-68 47.6-109.5v-5.8c0-69.9-50.5-129.5-119.4-141-45.6-7.6-92 7.3-124.6 39.9l-12 12-12-12c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5z"
								style="fill:#a5b9f6"
							/></svg
						>
						<a
							rel="noreferrer"
							href="/member/localactionrewards"
							class="block col-span-4 px-3 py-2 text-xs 2xl:text-base font-semibold 2xl:font-bold hover:bg-cosmicPurplebg"
							>Local Action Rewards</a
						>
					</li>
					<li class="grid grid-cols-5 items-center px-3 py-0 2xl:py-1 hover:bg-cosmicPurplebg">
						<svg
							xmlns="http://www.w3.org/2000/svg"
							viewBox="0 0 58.73 36.67"
							width="31"
							height="22"
							class="mx-auto lg:scale-75 2xl:scale-100 pt-1"
						>
							<path
								d="M3.63 36.55h.02c3.19-.98 6.35-2.1 9.43-3.37s6.09-2.7 9.01-4.28c5.55-3.03 10.79-6.66 15.25-11.05-5.3 8.22-18.98 16.53-18.98 16.53 8.75 2.97 16.34 3.44 23.01-2.8 6.38-5.97 9.06-13.08 12.08-21.4 2.08-5.73 5.28-9.15 5.28-9.15-7.28-.84-22.56-3.19-32.96 4.16-10.85 7.67-11.65 21.52-11.7 23.23-.79.23-1.58.45-2.37.67a99.47 99.47 0 0 1-9.34 2c-.11.02-.24.05-.36.08a2.81 2.81 0 0 0-1.87 3.5 2.81 2.81 0 0 0 3.5 1.87Z"
								style="fill:#a5b9f6;stroke-width:0"
							/>
						</svg>

						<a
							rel="noreferrer"
							href="/marketplace"
							class="col-span-4 block px-3 py-2 text-xs 2xl:text-base font-semibold 2xl:font-bold hover:bg-cosmicPurplebg"
							>Marketplace</a
						>
					</li>
				</ul>
			{/if}
		</li>

		<!-- Learn Section -->
		<li class="px-3 py-1">
			<button
				class="w-full flex items-center justify-between text-xs 2xl:text-base font-bold hover:bg-cosmicPurplebg px-2 py-1 rounded"
				on:click={() => toggleSection('learn')}
			>
				<span>Learn</span>
				<svg
					class="w-4 h-4 transform transition-transform {expandedSections.learn
						? 'rotate-180'
						: ''}"
					viewBox="0 0 20 20"
					fill="currentColor"
				>
					<path
						fill-rule="evenodd"
						d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
						clip-rule="evenodd"
					/>
				</svg>
			</button>
			{#if expandedSections.learn}
				<ul class="mt-1">
					<li class="grid grid-cols-5 items-center px-3 py-0 2xl:py-1 hover:bg-cosmicPurplebg">
						<svg
							class="mx-auto lg:scale-75 2xl:scale-100"
							id="b"
							xmlns="http://www.w3.org/2000/svg"
							width="28"
							height="28"
							viewBox="0 0 40 38"
							><defs
								><style>
									.f {
										fill: #a5b9f6;
										stroke-width: 0;
									}
								</style></defs
							><g id="c"
								><g id="d"
									><g id="e"
										><path
											class="f"
											d="M10.71 22.72h16.57c.13 0 .24.11.24.24v9.7c0 2.09-1.7 3.79-3.79 3.79h-9.47c-2.09 0-3.79-1.7-3.79-3.79v-9.7c0-.13.11-.24.24-.24ZM18.99 0C1.22 0-4.53 20.83 3.66 20.83h30.68C42.5 20.83 36.82 0 19 0ZM7.63 17.51c-1.57 0-2.84-1.27-2.84-2.84s1.27-2.84 2.84-2.84 2.84 1.27 2.84 2.84c0 1.57-1.27 2.84-2.84 2.84Zm13.25.47a7.571 7.571 0 0 1 0-15.14 7.571 7.571 0 0 1 0 15.14Z"
										/></g
									></g
								></g
							></svg
						>
						<a
							rel="noreferrer"
							href="/learn/templates"
							class="block col-span-4 px-3 py-2 text-xs 2xl:text-base font-semibold 2xl:font-bold hover:bg-cosmicPurplebg"
							>Resources to Grow Your Bloom</a
						>
					</li>
					<li class="grid grid-cols-5 items-center px-3 py-0 2xl:py-1 hover:bg-cosmicPurplebg">
						<svg
							class="mx-auto lg:scale-75 2xl:scale-100"
							version="1.1"
							id="Layer_1"
							xmlns="http://www.w3.org/2000/svg"
							x="0"
							y="0"
							width="28"
							height="28"
							viewBox="0 0 12.3 23.3"
							style="enable-background:new 0 0 12.3 23.3"
							xml:space="preserve"
							><style>
								.st0 {
									fill: #a5b9f6;
								}
							</style><path
								class="st0"
								d="M6 18.7c-1.1 0-1.9-.7-1.9-1.8S5 15 6 15c1 0 1.8.8 1.8 1.8 0 1.1-.7 1.9-1.8 1.9zM0 5.1C0 1.9 3.4 0 6.3 0c3 0 6 1.7 6 4.9 0 3.8-4.2 4-5 7.7-.3 1.9-3 1.8-3-.4 0-4.1 4.6-4.8 4.6-7.2 0-1.5-1.2-2.3-2.6-2.3-1.9 0-2.5 1.1-3.1 2.7C2.5 7.6 0 6.7 0 5.1z"
								style="fill:#a5b9f6"
							/></svg
						>
						<a
							rel="noreferrer"
							href="/learn/faq"
							class="block col-span-4 px-3 py-2 text-xs 2xl:text-base font-semibold 2xl:font-bold hover:bg-cosmicPurplebg"
							>FAQ</a
						>
					</li>
					<li class="grid grid-cols-5 items-center px-3 py-0 2xl:py-1 hover:bg-cosmicPurplebg">
						<svg
							class="mx-auto pl-[3px] pt-[1px]"
							id="b"
							xmlns="http://www.w3.org/2000/svg"
							width="21.81"
							height="23.15"
							><defs
								><style>
									.d {
										fill: #a5b9f6;
									}
								</style></defs
							><g id="c"
								><path
									class="d"
									d="M15.82 14.04h1.08c.28 0 .51-.22.51-.48v-1.61c0-.27-.23-.48-.51-.48h-1.08a.38.38 0 0 0-.39.37v1.83c0 .2.18.37.39.37ZM15.82 10.84h1.48c.28 0 .51-.22.51-.48V8.75c0-.27-.23-.48-.51-.48h-1.48a.38.38 0 0 0-.39.37v1.83c0 .2.18.37.39.37ZM15.82 7.65h1.08c.28 0 .51-.22.51-.48V5.56c0-.27-.23-.48-.51-.48h-1.08a.38.38 0 0 0-.39.37v1.83c0 .2.18.37.39.37ZM15.82 1.88h1.48c.28 0 .51.22.51.48v1.61c0 .27-.23.48-.51.48h-1.48a.38.38 0 0 1-.39-.37V2.25c0-.2.18-.37.39-.37ZM2.21 14.72C1 14.72 0 15.72 0 16.93s1 2.22 2.21 2.22h11.81c.33 0 .6-.27.6-.6 0-.33-.27-.6-.6-.6H2.21c-.57 0-1.01-.45-1.01-1.02s.45-1.01 1.01-1.01c.33 0 .6-.27.6-.6 0-.33-.27-.6-.6-.6Z"
								/><path
									class="d"
									d="M13.14 14.72c-.33 0-.6.27-.6.6v3.23c0 .33.27.6.6.6.33 0 .6-.27.6-.6v-3.23c0-.33-.27-.6-.6-.6Z"
								/><path
									class="d"
									d="M2.21 0C1 0 0 1 0 2.21v14.72h1.19a1 1 0 0 1 1.01-1.01h10.33c1.14 0 2.08-.94 2.08-2.08V2.07C14.62.93 13.68 0 12.54 0H2.21Z"
								/></g
							></svg
						>
						<a
							rel="noreferrer"
							href="/learn/wiki"
							class="block col-span-4 px-3 py-2 text-xs 2xl:text-base font-semibold 2xl:font-bold hover:bg-cosmicPurplebg"
							>Wiki</a
						>
					</li>
					<li class="grid grid-cols-5 items-center px-3 py-0 2xl:py-1 hover:bg-cosmicPurplebg">
						<svg
							class="mx-auto lg:scale-75 2xl:scale-100"
							width="25"
							height="29"
							xmlns="http://www.w3.org/2000/svg"
							viewBox="0 0 512 512"
							style="enable-background:new 0 0 512 512"
							xml:space="preserve"
							><path
								d="m47.6 300.4 180.7 168.7c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9l180.7-168.7c30.4-28.3 47.6-68 47.6-109.5v-5.8c0-69.9-50.5-129.5-119.4-141-45.6-7.6-92 7.3-124.6 39.9l-12 12-12-12c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5z"
								style="fill:#a5b9f6"
							/></svg
						>
						<a
							rel="noreferrer"
							href="https://docs.google.com/document/u/0/d/1eXL_CP6lnge-VOTzEDkmPKAsNd1xLBZBj2zuG4DSFKk/"
							class="block col-span-4 px-3 py-2 text-xs 2xl:text-base font-semibold 2xl:font-bold hover:bg-cosmicPurplebg"
							>Code of Conduct</a
						>
					</li>
				</ul>
			{/if}
		</li>
	</ul>
</aside>

<!-- <button on:click={toggleDrawer}>Toggle Drawer</button> -->

<style>
	a {
		color: #a5b9f6;
		font-size: small;
	}

	div {
		font-size: small; /* 20px, adjust as necessary */
	}

	button {
		color: #a5b9f6;
		width: 100%;
		text-align: left;
	}

	@media (min-width: 1536px) {
		a,
		button {
			font-size: medium;
		}

		div {
			font-size: medium; /* 16px for 2xl and larger screens */
		}
	}

	/* Add smooth transitions for section expansion/collapse */
	ul ul {
		transition: all 0.3s ease-in-out;
		overflow: hidden;
	}

	/* Style for section headers */
	button[class*='flex items-center justify-between'] {
		border-radius: 0.25rem;
		padding: 0.5rem;
		margin-bottom: 0.25rem;
		border: 1px solid #59127b;
	}

	button[class*='flex items-center justify-between']:hover {
		background-color: rgba(165, 185, 246, 0.1);
	}
</style>
